import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../styled/flexbox.styled"

export const ToggleInputContainer = styled(FlexContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`
